module.exports = __webpack_public_path__ + "static/img/vue.cf23526f.png";